module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>man-icon</title><path d=\"M25,.17,3.5,12.59V37.41l7.07,4.08c3.73-3.11,7.24-6.06,7.26-6.25a64.5,64.5,0,0,0,3.61,12.53l2.35-8.27-1.22-2.32h4.87l-1.22,2.32,2.25,8.33A65.27,65.27,0,0,0,32,35.58c0,.19,3.43,3.06,7.1,6.13l7.44-4.3V12.59ZM31.92,27c-.86,4.12-2.76,7.6-6.89,7.6s-6-3.44-6.87-7.51h0s-2.42-2.82-2.58-4.92A1.85,1.85,0,0,1,17.46,20c0-2,0-3.75,0-4.88,0-4.6,7.56-4.49,7.56-4.49s7.56-.11,7.56,4.49c0,1.13.06,2.89,0,4.89a1.78,1.78,0,0,1,1.81,2.11C34.27,24,32.32,26.48,31.92,27Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/man-icon-01.svg
// module id = 551
// module chunks = 1